import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';

const { FiCheck, FiArrowRight, FiHelpCircle } = FiIcons;

// ポータルURL（更新されたURL）
const PORTAL_URL = 'https://member.digicollab.net';

function App() {
  const handlePortalClick = () => {
    window.open(PORTAL_URL, '_blank', 'noopener,noreferrer');
  };

  const handleSupportClick = () => {
    window.open('https://www.digishift.co.jp/contact', '_blank', 'noopener,noreferrer');
  };

  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  const staggerContainer = {
    animate: {
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const listItems = [
    'はじめのアンケート（2〜3分）',
    '納品物（LP／診断ツール）のご案内',
    '修正依頼（スクショ注釈）',
    '特典（LINE作成マニュアル 等）',
    'ウェルカムセッションの予約'
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-amber-50">
      {/* 追跡コード用スロット */}
      <div id="tracking-slot"></div>
      
      {/* ヘッダー */}
      <header className="w-full px-4 py-6 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto flex justify-between items-center">
          <div className="text-xl font-bold text-orange-800">
            AI導線スタートパック
          </div>
          <button 
            onClick={handleSupportClick}
            className="text-orange-600 hover:text-orange-800 transition-colors duration-200 flex items-center gap-2 text-sm sm:text-base"
            aria-label="サポートページへ移動"
          >
            <SafeIcon icon={FiHelpCircle} className="w-4 h-4" />
            サポート
          </button>
        </div>
      </header>

      {/* メインコンテンツ */}
      <main className="px-4 pb-12 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto">
          
          {/* ヒーローセクション */}
          <motion.div 
            className="text-center mb-12"
            initial="initial"
            animate="animate"
            variants={staggerContainer}
          >
            <motion.div 
              className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-6"
              variants={fadeInUp}
            >
              <SafeIcon icon={FiCheck} className="w-8 h-8 text-green-600" />
            </motion.div>
            
            <motion.h1 
              className="text-3xl sm:text-4xl font-bold text-gray-800 mb-4"
              variants={fadeInUp}
            >
              ご購入ありがとうございます
            </motion.h1>
            
            <motion.p 
              className="text-lg text-gray-600 mb-8 leading-relaxed"
              variants={fadeInUp}
            >
              続きのご案内は専用ポータルにまとめています。<br className="hidden sm:block" />
              下のボタンからお進みください。
            </motion.p>
            
            <motion.button
              onClick={handlePortalClick}
              className="inline-flex items-center gap-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold px-8 py-4 rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1 text-lg min-h-[56px]"
              variants={fadeInUp}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              aria-label="専用ポータルに進む"
            >
              専用ポータルに進む
              <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
            </motion.button>
          </motion.div>

          {/* 本文セクション */}
          <motion.div 
            className="bg-white rounded-2xl shadow-sm border border-orange-100 p-6 sm:p-8 mb-8"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <h2 className="text-xl font-semibold text-gray-800 mb-6 text-center">
              ポータルでご確認いただけること
            </h2>
            
            <motion.ul 
              className="space-y-4"
              variants={staggerContainer}
              initial="initial"
              animate="animate"
            >
              {listItems.map((item, index) => (
                <motion.li 
                  key={index}
                  className="flex items-start gap-3 text-gray-700"
                  variants={fadeInUp}
                  transition={{ delay: 0.4 + index * 0.1 }}
                >
                  <div className="flex-shrink-0 w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center mt-0.5">
                    <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                  </div>
                  <span className="text-base leading-relaxed">{item}</span>
                </motion.li>
              ))}
            </motion.ul>
          </motion.div>

          {/* 注意書き */}
          <motion.div 
            className="bg-amber-50 border border-amber-200 rounded-xl p-4 sm:p-6 text-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.8 }}
          >
            <p className="text-amber-800 text-sm sm:text-base">
              <span className="font-medium">📧 アクセス用パスワードはメールでもお送りしています。</span>
            </p>
          </motion.div>
        </div>
      </main>
    </div>
  );
}

export default App;